export enum ENUM_TYPES {
  NORMAL = 'normal',
  CREATE = 'create',
  BATCH = 'batch',
  MERGE = 'merge',
  LOGISTICS = 'logistics',
}

export enum ENUM_FILTER_TYPE {
  /**
   * 货到付款
   */
  COD = '1',
  /**
   * 保险
   */
  INSURANCE = '2',
}

export enum SHIPMENT_PICKUP_TYPE {
  // 上门取货
  pickUp = 1,
  // 自邮
  dropOff = 2,
}

/**收件人证件类型 */
export enum CONSIGNEE_CERTTIFICATE_TYPE {
  // 身份证
  idCard = 1,
  // 护照
  passport = 2,
  // 港澳通行证
  ghPass = 3,
  // 回乡证
  hxPass = 4,
  // 台胞证
  tbPass = 5,
  // 赴台同学证
  twPass = 6,
  // 其他
  other = 7,
}

/**使用场景：订单/运单 */
export enum SCENE_TYPE {
  order = 'order',
  logistic = 'logistic',
}

/**
 * COD TAB
 */
export enum COD_TAB {
  ALL,
  COD,
  NO_COD,
}

export enum PaymentTypeEnum {
  cod = 1,
  notCod = 2,
}

/** 自定义运费 */
export enum CUSTOM_FREIGHT_REASON_ENUM {
  /** oneship 计算方式错误  */
  ONESHIP_ERROR = 'LST-123672-B1142',
  /** 未配置运费规则/或者未开启 */
  IGNORE = 'LST-123672-B1140',
  /** 命中 */
  NO_IN_RANGE = 'LST-123672-B1141',

  /**
   * 无法使用
   */
  CAN_NOT_USE = 'FREIGHT-123672-B1141',
}
